import React, { Component } from "react";
import { connect } from "dva";
import EnhancerWaterMark from "watermark-enhancer";
import { parse, stringify } from "qs";
import { queryCurrent } from "@/services/user";
import Container from "../../../../../components/Container";
import Detail from "../../Components/Detail";

const renderEffectContent = async () => {
  const { phone, users = [] } = await queryCurrent();
  const { userName } = users.find(user => user.userType && user.userType !== "学生");
  return `${userName}${phone.slice(-4)}`;
};

@EnhancerWaterMark({
  width: "280",
  height: "300",
  rotate: "335",
  font: "16px normal  PingFang SC",
  fillStyle: "rgba(184, 184, 184, 0.2)",
  asyncContent: renderEffectContent
}, {
  content: "",
  color: "black",
  background: "white"
})

@connect(({ mySalary }) => ({
  ...mySalary,
}))
class Index extends Component {

  constructor(props) {
    super(props);
    this.query = parse(window.location.search.split("?")[1]);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { id } = this.query
    dispatch({
      type: 'mySalary/fetchDetail',
      payload: {
        id,
        page: 1,
        pageSize: 10,
      },
    })
  }


  render() {
    const { detailsData } = this.props;
    return (
      <Container
        defaultPadding
        breStates
        isSplitBar
      >
        <Detail data={detailsData} />
      </Container>
    );
  }
}

export default Index;
